import React from 'react';
import { Transaction } from '../types/budget';
import { TransactionTableHeader } from './TransactionTableHeader';
import { TransactionTableRow } from './TransactionTableRow';
import { TransactionTableFooter } from './TransactionTableFooter';

type SortField = 'category' | 'responsible' | 'description' | 'destination' | 'amount';
type SortDirection = 'asc' | 'desc';

interface TransactionTableProps {
  transactions: Transaction[];
  sortField: SortField;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
  onEdit: (transaction: Transaction) => void;
  onDelete: (transaction: Transaction) => void;
  onCreateInverse?: (transaction: Transaction) => void;
  showActions?: boolean;
}

export const TransactionTable: React.FC<TransactionTableProps> = ({
  transactions,
  sortField,
  sortDirection,
  onSort,
  onEdit,
  onDelete,
  onCreateInverse,
  showActions = true,
}) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
        <TransactionTableHeader
          sortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
          showActions={showActions}
        />
        <tbody className="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-gray-800">
          {transactions.map((transaction, index) => (
            <TransactionTableRow
              key={transaction.id || index}
              transaction={transaction}
              index={index}
              onEdit={onEdit}
              onDelete={onDelete}
              onCreateInverse={onCreateInverse}
              showActions={showActions}
            />
          ))}
        </tbody>
        <TransactionTableFooter transactions={transactions} />
      </table>
    </div>
  );
};
